module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar-wrap"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/chaye/icon1.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("可追溯商品数量")]), _vm._v(" "), _c('p', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 1286708,
      "endVal": 2286708,
      "duration": 5000
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/chaye/icon2.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("累计扫码量")]), _vm._v(" "), _c('p', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 10785098,
      "endVal": 18785098,
      "duration": 5000
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/chaye/icon3.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("区块链存证批次数量")]), _vm._v(" "), _c('p', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 62480,
      "duration": 5000
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../../../assets/img/chaye/icon4.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("区块链存证节点数量")]), _vm._v(" "), _c('p', [_c('countTo', {
    staticClass: "count",
    attrs: {
      "startVal": 0,
      "endVal": 1376682,
      "duration": 5000
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e398c52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/chaye/components/item1/index.vue
// module id = 2014
// module chunks = 2